import React from "react";
import { descriptionParts, badgesOf } from "./signalMeta";

/** Free (green) plus at most one of Deep intel or AI-ranked for you. */
export const Badges = ({ def }) => {
  const badges = badgesOf(def);
  return badges.length ? (
    <div className="sg-card__badges">
      {badges.map(b => <span key={b.key} className={`sg-pill ${b.key === "free" ? "sg-pill--live" : "sg-pill--tier"}`}>{b.label}</span>)}
    </div>
  ) : null;
};

/** What we read, what you get and an example; `fallback` renders when the server sent a single line. */
const SignalDescription = ({ def, fallback = null }) => {
  const p = descriptionParts(def);
  if (!p) return fallback;
  return (
    <div className="sg-desc">
      {p.reads && <div className="sg-desc__row"><b>What we read</b><span>{p.reads}</span></div>}
      {p.gives && <div className="sg-desc__row"><b>What you get</b><span>{p.gives}</span></div>}
      {p.example && <div className="sg-desc__ex">Example: {p.example}</div>}
    </div>
  );
};

export default SignalDescription;
